import { MoreVertical } from "lucide-react";
import { useTranslation } from "@/shared/providers/LanguageProvider";

type CardMenuProps = {
  onClick?: () => void;
};

export function CardMenu({ onClick }: CardMenuProps) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={onClick}
      className="text-muted hover:text-muted-foreground"
      aria-label={t.common.options}
    >
      <MoreVertical size={18} />
    </button>
  );
}
